import {
  getInstructionSequenceLength,
  type InstructionPayload
} from "./schema";
import type { InstructionSessionState } from "./session";

export const INSTRUCTION_HINT_SCORE_PENALTY = 5;
export const INSTRUCTION_UNDO_SCORE_PENALTY = 2;

export interface InstructionScore {
  readonly score: number;
  readonly completed: boolean;
  readonly completionRate: number;
  readonly correctRate: number;
  readonly hintCount: number;
  readonly retryCount: number;
  readonly undoCount: number;
  readonly replayCount: number;
}

function clampRate(value: number): number {
  return Math.min(1, Math.max(0, value));
}

export function calculateInstructionScore(
  payload: InstructionPayload,
  state: InstructionSessionState
): InstructionScore {
  const totalActionAttempts =
    state.acceptedActionCount + state.retryCount;
  const correctRate =
    totalActionAttempts === 0
      ? 0
      : clampRate(state.acceptedActionCount / totalActionAttempts);
  const sequenceLength = getInstructionSequenceLength(payload);
  const completionRate =
    sequenceLength === 0
      ? 0
      : clampRate(state.responses.length / sequenceLength);
  const supportPenalty =
    state.hintState.hintCount * INSTRUCTION_HINT_SCORE_PENALTY +
    state.undoCount * INSTRUCTION_UNDO_SCORE_PENALTY;
  const score = Math.round(
    Math.min(
      100,
      Math.max(0, 100 * completionRate * correctRate - supportPenalty)
    )
  );

  return {
    score,
    completed: state.status === "completed",
    completionRate,
    correctRate,
    hintCount: state.hintState.hintCount,
    retryCount: state.retryCount,
    undoCount: state.undoCount,
    replayCount: state.replayCount
  };
}
